import React from 'react';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: January 1, 2025</p>
        
        <section>
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide directly to us, such as when you:</p>
          <ul>
            <li>Fill out our contact form</li>
            <li>Request a consultation</li>
            <li>Subscribe to our newsletter</li>
            <li>Communicate with us via email or phone</li>
          </ul>
          
          <h3>Personal Information</h3>
          <p>This may include:</p>
          <ul>
            <li>Name and contact information (email, phone number, address)</li>
            <li>Project details and requirements</li>
            <li>Communication preferences</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and improve our architectural and interior design services</li>
            <li>Respond to your inquiries and requests</li>
            <li>Send you project updates and communications</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>3. Information Sharing and Disclosure</h2>
          <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except:</p>
          <ul>
            <li>To trusted service providers who assist us in operating our business</li>
            <li>When required by law or to protect our rights</li>
            <li>With your explicit consent</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
        </section>

        <section>
          <h2>5. Your Rights Under Indian Law</h2>
          <p>Under the Information Technology Act, 2000 and related rules, you have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Withdraw consent for processing</li>
          </ul>
        </section>

        <section>
          <h2>6. Cookies and Tracking</h2>
          <p>Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings.</p>
        </section>

        <section>
          <h2>7. Changes to This Policy</h2>
          <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated "last modified" date.</p>
        </section>

        <section>
          <h2>8. Contact Information</h2>
          <p>If you have any questions about this Privacy Policy, please contact us:</p>
          <div className="contact-details">
            <p><strong>Prangio Designs Pte. Ltd.</strong></p>
            <p>21/22, Alandur Road, WeWork Olympia Cyberspace</p>
            <p>Arulayiammanpet, 2nd Street, Guindy, Chennai 600032</p>
            <p>Email: prangiodesigns@gmail.com</p>
            <p>Phone: +91 (776) 003-4934</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
